import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { PIC } from "@ryde/assets";
import { FloatingMenuButton } from "@ryde/controls";
import { useNotificationsBulkActions, usePageContext } from "@ryde/redux";
import { Log, selectedTableRowsIdsAtomFamily } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const NotificationsFloatingElements = (): ReactElement => {
  const { t } = useTranslation();
  const { entity } = usePageContext();
  const { bulkUpdateMarkAsRead, bulkUpdateResolved } =
    useNotificationsBulkActions();
  const selectedRideIds = useRecoilValue(
    selectedTableRowsIdsAtomFamily(entity),
  );

  const handleMarkAsReadClick = async (): Promise<void> => {
    try {
      await bulkUpdateMarkAsRead(selectedRideIds);
    } catch (e: unknown) {
      Log.warnAndToast(t("errors.errorBulkUpdatingData"), e);
    }
  };

  const handleResolvedClick = async (): Promise<void> => {
    try {
      await bulkUpdateResolved(selectedRideIds);
    } catch (e: unknown) {
      Log.warnAndToast(t("errors.errorBulkUpdatingData"), e);
    }
  };

  return (
    <>
      <FloatingMenuButton onClick={handleMarkAsReadClick}>
        <PIC.IsRead color={greyMui.A700} />
        <span>{t("notification.formLabel.markAsRead")}</span>
      </FloatingMenuButton>
      <FloatingMenuButton onClick={handleResolvedClick}>
        <span>{t("notification.RESOLVED")}</span>
      </FloatingMenuButton>
    </>
  );
};
